// extracted by mini-css-extract-plugin
export var lbContainerOuter = "r_qG";
export var lbContainerInner = "r_qH";
export var movingForwards = "r_qJ";
export var movingForwardsOther = "r_qK";
export var movingBackwards = "r_qL";
export var movingBackwardsOther = "r_qM";
export var lbImage = "r_qN";
export var lbOtherImage = "r_qP";
export var prevButton = "r_qQ";
export var nextButton = "r_qR";
export var closing = "r_qS";
export var appear = "r_qT";